angular.module('mercury.modules.qa', [
  'mercury.modules.qa.bepoz',
  'mercury.modules.qa.menumate',
  'mercury.modules.qa.idealpos',
  'mercury.modules.qa.swiftpos',
  'mercury.modules.qa.wizbang'
]);
